<template>
  <div>
    <div class="contact">
      <p>{{details.message}}</p>
      <p class>
        {{details.name}}
        <br>
        {{details.address1}}
        <br>
        {{details.address2}}
        <br>
        {{details.country}}
        <br>
        <br>
        {{details.phone1}}
        <br>
        {{details.phone2}}
        <br>
        <br>
        {{details.email}}
        <br>
      </p>
    </div>
    <div id="map" class="mx-auto"></div>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import {mapState} from "vuex"

export default {
  computed: {
    ...mapState(["config"]),
    details() {
      return {
        name: this.config.name,
        address1: this.config.address1,
        address2: this.config.address2,
        phone1: this.config.phone1,
        phone2: this.config.phone2,
        email: this.config.email,
        country: this.config.country,
        message: this.config.contactMsg,
        coords: this.$_.map(this.$_.split(this.config.coordinates, ","), parseFloat),
      };
    }
  },
  mounted() {
    let map = L.map("map", { center: this.details.coords, zoom: 15, maxZoom: 15});
    var Stamen_Watercolor = L.tileLayer(
      "https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.{ext}",
      {
        attribution:
          'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        subdomains: "abcd",
        minZoom: 1,
        maxZoom: 16,
        ext: "jpg"
      }
    ).addTo(map);
    var Stamen_TonerLabels = L.tileLayer(
      "https://stamen-tiles-{s}.a.ssl.fastly.net/toner-labels/{z}/{x}/{y}{r}.{ext}",
      {
        attribution:
          'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        subdomains: "abcd",
        minZoom: 0,
        maxZoom: 20,
        ext: "png"
      }
    ).addTo(map);
    L.circleMarker(this.details.coords, { radius: 10, color: "#42b983" }).addTo(map);
  }
};
</script>

<style>
#map {
  min-height: 30em;
  display: block;
}
.contact {
  text-align: center;
}
</style>

